import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import {TSKantonCode} from './enums/TSKantonCode';

export default class TSGemeinde extends TSAbstractEntity implements TSSerializable<TSGemeinde> {

    private _name: string;
    private _kanton: TSKantonCode;

    public get kanton(): TSKantonCode {
        return this._kanton;
    }

    public set kanton(value: TSKantonCode) {
        this._kanton = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    deserialize(restObject: any): TSGemeinde {
        super.deserialize(restObject);

        this.name = restObject.name;
        this.kanton = restObject.kanton;
        return this;
    }

    public static deserializeArray(data: any): Array<TSGemeinde> {
        let anlaufstelleArray: Array<TSGemeinde> = [];
        if (data && Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                anlaufstelleArray[i] = new TSGemeinde().deserialize(data[i]);
            }
        } else {
            anlaufstelleArray[0] = new TSGemeinde().deserialize(data);
        }
        return anlaufstelleArray;
    }

    public static getDeserializer = (gemeinde: any) => {
        return new TSGemeinde().deserialize(gemeinde);
    };

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.name = this.name;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSGemeinde.ts